import { Link } from 'react-router-dom';
import './signupPending.css';

const SignupPendingPage = () => {
    return (
        <div className="pending-shell">
            <div className="pending-card">
                <div className="pending-icon">✓</div>
                <h2>Thanks — we'll be in touch!</h2>
                <p>Your account request has been received. We'll review it shortly and send you an email once you're approved.</p>
                <Link to="/" className="pending-home-link">Back to Home</Link>
            </div>
        </div>
    );
};

export default SignupPendingPage;
